import { apiGet, apiPost, apiPut } from "./http";

export type MemberNoRuleDto = {
  tenantPrefix: string;
  separator: string;
  digits: number;
  levelPrefixes: Record<string, string>;
  seqNext: number;
};

export type MemberNoRuleWriteBody = {
  tenantPrefix?: string;
  separator?: string;
  digits?: number;
  levelPrefixes?: Record<string, string>;
  seqNext?: number;
};

export type ReservedMemberNoDto = {
  id: string;
  sequenceTail: string;
  category: string;
  note: string;
  sortOrder: number;
  isEnabled: boolean;
  isAssigned: boolean;
  assignedMemberName?: string | null;
};

export type ReservedMemberNoWriteItem = {
  sequenceTail: string;
  category?: string;
  note?: string;
  sortOrder?: number;
  isEnabled?: boolean;
};

export type ReservedGenerateCategory = "leopard" | "homophone" | "straight" | "doublePair";

const categoryLabels: Record<ReservedGenerateCategory, string> = {
  leopard: "豹子号",
  homophone: "谐音号",
  straight: "连号",
  doublePair: "双连号",
};

export function reservedCategoryLabel(cat: string): string {
  const normalized = String(cat || "").trim().toLowerCase();
  const alias: Record<string, ReservedGenerateCategory> = {
    doublepair: "doublePair",
    double_pair: "doublePair",
  };
  const k = (alias[normalized] ?? normalized) as ReservedGenerateCategory;
  return categoryLabels[k] || cat || "手动";
}

export function fetchMemberNoRule(tenantLegacyId: string) {
  return apiGet<MemberNoRuleDto>(`/api/tenants/${encodeURIComponent(tenantLegacyId)}/member-no-rule`);
}

export function putMemberNoRule(tenantLegacyId: string, body: MemberNoRuleWriteBody) {
  return apiPut<{ ok: boolean }>(`/api/tenants/${encodeURIComponent(tenantLegacyId)}/member-no-rule`, body);
}

export function fetchReservedMemberNos(tenantLegacyId: string) {
  return apiGet<ReservedMemberNoDto[]>(
    `/api/tenants/${encodeURIComponent(tenantLegacyId)}/member-no-rule/reserved`,
  );
}

export function putReservedMemberNos(tenantLegacyId: string, items: ReservedMemberNoWriteItem[]) {
  return apiPut<{ ok: boolean }>(
    `/api/tenants/${encodeURIComponent(tenantLegacyId)}/member-no-rule/reserved`,
    { items },
  );
}

export function generateReservedMemberNos(tenantLegacyId: string, category: ReservedGenerateCategory) {
  return apiPost<{ addedCount: number }>(
    `/api/tenants/${encodeURIComponent(tenantLegacyId)}/member-no-rule/reserved/generate`,
    { category },
  );
}

export function changeMemberNo(
  tenantLegacyId: string,
  memberLegacyId: string,
  memberNo: string,
) {
  return apiPut<{ memberNo: string }>(
    `/api/tenants/${encodeURIComponent(tenantLegacyId)}/members/${encodeURIComponent(memberLegacyId)}/member-no`,
    { memberNo },
  );
}
